// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3OhcH","label":"Category_label__2_8kU","content":"Category_content__r7I_5","header":"Category_header__22Bmb","location":"Category_location__EpYGv"};